import { useEffect, useMemo, useState } from "react";
import { Link, Navigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { getExpertApprovalStatus, hasApprovedExpertAccess } from "@/lib/expertAccess";
import ExpertProfileForm, { expertFormValues } from "@/components/profile/ExpertProfileForm";
import ProfessionalQualifications from "@/components/profile/ProfessionalQualifications";

export default function PendingExpertProfile() {
  const { user, refresh } = useAuth();
  const [categories, setCategories] = useState([]);
  const [categoriesError, setCategoriesError] = useState("");
  const [saved, setSaved] = useState(false);
  const profile = user?.expert_profile;

  const loadCategories = () => {
    setCategoriesError("");
    api.get("/categories")
      .then((response) => setCategories(response.data))
      .catch(() => setCategoriesError("Fagområderne kunne ikke indlæses."));
  };

  useEffect(() => { loadCategories(); }, []);

  const initialValues = useMemo(() => expertFormValues(user, profile), [user, profile]);

  if (hasApprovedExpertAccess(user)) return <Navigate to="/expert?tab=profile" replace />;
  if (getExpertApprovalStatus(user) !== "pending") return <Navigate to="/expert/onboarding" replace />;

  const save = async (payload) => {
    const { full_name, ...profileUpdate } = payload;
    await api.put("/users/me/profile", {
      name: full_name,
      photo_url: payload.photo_url,
      city: user?.city || "",
      language: payload.languages[0] || user?.language || "Dansk",
    });
    await api.put("/expert/profile", profileUpdate);
    await refresh();
    setSaved(true);
  };

  return (
    <main className="min-h-screen bg-brand-wash">
      <div className="max-w-3xl mx-auto px-4 py-8 sm:py-12">
        <div className="flex items-center justify-between gap-3 flex-wrap">
          <div>
            <div className="font-mono uppercase text-[11px] tracking-widest text-brand-muted">Ekspertprofil</div>
            <h1 className="font-display text-3xl font-bold text-brand-ink">Min profil</h1>
            <p className="mt-2 text-sm text-brand-muted">Profilen afventer godkendelse. Du kan stadig rette dine profiloplysninger.</p>
          </div>
          <Link to="/expert/afventer-godkendelse" className="btn-secondary">Se profilstatus</Link>
        </div>
        {saved && <div className="mt-5 rounded-xl border border-brand-line-strong bg-brand-soft px-4 py-3 text-sm text-[#166534]" role="status">Din profil er gemt.</div>}
        <div className="mt-6">
          <ExpertProfileForm
            initialValues={initialValues}
            categories={categories}
            categoriesError={categoriesError}
            onRetryCategories={loadCategories}
            onSubmit={save}
            submitLabel="Gem profil"
            testId="pending-expert-profile-form"
          />
        </div>
        <div className="mt-6"><ProfessionalQualifications/></div>
      </div>
    </main>
  );
}

